import { parseCustomer } from '@/customer/converters/customerConverters';
import Customer from '@/customer/models/Customer';
import Dossier from '@/dossier/models/Dossier';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import { parseMobilitySolution } from '@/shared/converters/mobolitySolutionConverters';
import { parseOutlet } from '@/shared/converters/outletConverters';
import { parseReceptionTypeConverter } from '@/shared/converters/receptionTypeConverters';
import { parseTags } from '@/shared/converters/tagConverters';
import { parseUser } from '@/shared/converters/userConverters';
import Outlet from '@/shared/models/Outlet';
import User from '@/shared/models/User';
import { isPresent } from '@/shared/utils/typescript';
import { parseVehicle } from '@/vehicle/converters/vehicleConverters';
import Vehicle from '@/vehicle/models/Vehicle';
import Booking from '../models/Booking';
import { parseBookingItems } from './bookingItemConverters';

const SCHEMA = {
  id: (data: any) => data.document?.id ?? data.id,
  createdOn: (data: any) => parseMoment(data.document?.createdOn ?? data.createdOn),
  appointmentOn: (data: any) => parseMoment(data.document?.appointment ?? data.appointment, DateTimeFormat.LEGACY),
  bringsDayBefore: 'document.bringsDayBefore',
  customer: (data: any) => data.customerName ? Customer.withFullName(data.customerName) : parseCustomer(data.contact),
  dossier: parseDossier,
  items: (data: any) => parseBookingItems(data.serviceBookingItems),
  mobilitySolution: (data: any) => parseMobilitySolution(data.document?.mobilitySolution),
  outlet: (data: any) => parseOutlet(data.outlet || data.document?.outlet) ?? Outlet.withData({ id: data.outletId }),
  ownedOn: (data: any) => parseMoment(data.ownedOn),
  owner: (data: any) => data.ownedBy ? parseUser(data.ownedBy) : User.withId(data.ownedById),
  pinId: 'pinId',
  progressCategory: (data: any) => data.status,
  receptionType: (data: any) => parseReceptionTypeConverter(data.document?.receptionType),
  status: (data: any) => data.document?.status.id,
  tags: (data: any) => data.document?.tags || data.tags,
  unreadMessages: 'unreadMessages',
  vehicle: (data: any) => data.subject ? parseVehicle(data.subject) : Vehicle.withData({ registrationNumber: data.registrationNumber, modelDescription: data.modelDescription }),
  waitsOnPremise: (data: any) => data.document?.waitsOnPremise ?? data.waitsOnPremise ?? false,
};

const DOSSIER_SCHEMA = {
  id: 'dossierId',
  outletId: 'document.outlet.moboOutletId',
  tags: (data: any) => parseTags(data.document.tags),
};

export function parseDossier(data: any): Dossier | null {
  return isPresent(data.dossierId) ? parseEntity(data, DOSSIER_SCHEMA, Dossier) : null;
}

export function parseBooking(data: any): Booking | null {
  return parseEntity(data, SCHEMA, Booking);
}

export function parseBookings(data: any): Array<Booking> {
  return parseEntities(data, parseBooking);
}